<template>
  <div>
    <PageAllow controller="LakalaInterface" action="createUserForBalance" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          <span>
            {{ $t("LakalaAccount.CreateUser.newInfo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="$router.push('/lakala')"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("LakalaAccount.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <!-- 公司名称 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("LakalaAccount.CreateUser.company_name") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    single-line
                    v-model="lakalaAccount.company_name"
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 账户编码 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("LakalaAccount.CreateUser.out_member_no") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    single-line
                    v-model="userInfo.out_member_no"
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 会员类型 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("LakalaAccount.CreateUser.member_type") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('LakalaAccount.CreateUser.member_type')"
                    rules="required"
                  >
                    <v-autocomplete
                      color="primary"
                      hide-no-data
                      v-model="memberTypeSelected"
                      :items="$consts.subAccountSettings.member_type"
                      item-text="text"
                      item-value="value"
                      item-disabled="disabled"
                      return-object
                      :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- 右侧按钮 -->
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="$router.push('/lakala')"
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", []) }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="success"
                  block
                  :disabled="loading"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", []) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ThirdAccountInfo from "@/api/third-account-info"
import LakalaInterface from "@/api/lakala_interface"

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.thirdPayment"),
          disabled: false,
          href: "/lakala",
        },
        {
          text: i18n.t("Nav.lakalaAccount"),
          disabled: true,
          href: "/lakala",
        },
        {
          text: i18n.t("LakalaAccount.CreateUser.newInfo"),
          disabled: true,
          href: "/lakala",
        },
      ];
    },
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "new";
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    mode: '',
    lakalaAccount: {},
    userInfo:{},
    memberTypeSelected: null,
  }),

  mounted() {
    this.mode = 'new'
    this.getThirdAccountFromAPI(this.$route.params.id);
  },

  methods: {
    getThirdAccountFromAPI(id) {
      ThirdAccountInfo.fetchOne(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.lakalaAccount = response.data.third_account;
            this.memberTypeSelected = 2;
            this.userInfo = {
              out_member_no: this.lakalaAccount.lakala_out_member_no,
              member_type: 2
            }
          }
        }.bind(this)
      );
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            //整理提交数据
            LakalaInterface.createUserForBalance(this.userInfo).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$snackbar.success(i18n.t("MaterialOrderRule.Messages.saveSuccess"));
                  window.open(response.data.result.url,'_blank');
                  this.$router.replace("/lakala");
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            ).catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    memberTypeSelected: {
      deep: true,
      handler() {
        if (this.memberTypeSelected) {
          if (this.memberTypeSelected.value) {
            this.userInfo.member_type = this.memberTypeSelected.value;
          }else {
            this.userInfo.member_type = this.memberTypeSelected;
          }
        }else {
          this.userInfo.member_type = null;
        }
      }
    },
  }
};
</script>